import React from "react";
import { useTranslation } from "react-i18next";
import { 
  SiSublimetext, 
  SiJupyter, 
  SiGithub, 
  SiOverleaf, 
  SiDocker, 
  SiVisualstudiocode, 
  SiPostgresql 
} from "react-icons/si";
import { FaWindows } from 'react-icons/fa'; 
import SkillSlider from "./SkillSlider"; // Assure-toi que le chemin est correct

function Toolstack() {
  const { t } = useTranslation();

  // On prépare les données proprement pour le composant générique
  const tools = [
    { icon: FaWindows, name: "Windows", desc: t("tool_windows_desc") },
    { icon: SiSublimetext, name: "Sublime Text", desc: t("tool_sublime_desc") },
    { icon: SiJupyter, name: "Jupyter Notebook", desc: t("tool_jupyter_desc") },
    { icon: SiVisualstudiocode, name: "VS Code", desc: t("tool_vscode_desc") },
    { icon: SiPostgresql, name: "PostgreSQL", desc: t("tool_postgresql_desc") },
    { icon: SiDocker, name: "Docker", desc: t("tool_docker_desc") },
    { icon: SiGithub, name: "GitHub", desc: t("tool_github_desc") },
    { icon: SiOverleaf, name: "Overleaf", desc: t("tool_overleaf_desc") },
  ];

  return (
    <div className="toolstack-section-container">
      {/* On appelle le slider avec la variante "secondary".
          Le composant SkillSlider gère déjà le thème, le mobile et l'autoplay.
      */}
      <SkillSlider data={tools} variant="secondary" />
    </div>
  );
}

export default Toolstack;